import CarrionWrapper from "../pages/carrion";
import CarrionListWrapper from "../pages/carrion/list/CarrionListWrapper";
import CarrionProfileLayout from "../pages/carrion/profile/CarrionProfileLayout";
import CarrionInfo from "../pages/carrion/profile/view/CarrionInfo";
import CarrionPhotos from "../pages/carrion/profile/view/CarrionPhotos";
import CensusWrapped from "../pages/census";
import CensusListWrapper from "../pages/census/list/CensusListWrapped";
import CensusProfileLayout from "../pages/census/profile/CensusProfileLayout";
import CensusInfo from "../pages/census/profile/view/CensusInfo";
import CensusPhotos from "../pages/census/profile/view/CensusPhotos";
import OfcWrapper from "../pages/ofc";
import OfcListWrapper from "../pages/ofc/list/OfcListWrapped";
import OfcProfileLayout from "../pages/ofc/profile/OfcProfileLayout";
import OfcInfo from "../pages/ofc/profile/view/OfcInfo";
import OfcPhotos from "../pages/ofc/profile/view/OfcPhotos";
import ClientsWrapper from "../pages/clients";
import ClientCreate from "../pages/clients/create/ClientCreate";
import ClientEdit from "../pages/clients/edit/ClientEdit";
import ClientsListWrapper from "../pages/clients/list/ClientsListWrapper";
import ClientInfo from "../pages/clients/profile/views/info/ClientInfo";
import Dashboard from "../pages/dashboard/Dashboard";
import DocumentsWrapper from "../pages/docs";
import DocumentsListWrapper from "../pages/docs/list/DocumentsListWrapper";
import IssuesWrapper from "../pages/issue";
import IssuesListWrapper from "../pages/issue/list/IssuesListWrapper";
import IssuesProfileLayout from "../pages/issue/profile/IssuesProfileLayout";
import IssuesInfo from "../pages/issue/profile/view/IssuesInfo";
import IssuesPhotos from "../pages/issue/profile/view/IssuesPhotos";
import OrganisationWrapper from "../pages/organisations";
import OrganisationCreate from "../pages/organisations/create/OrganisationCreate";
import OrganisationEdit from "../pages/organisations/edit/OrganisationEdit";
import OrganisationsListWrapper from "../pages/organisations/list/OrganisationsListWrapper";
import ParksWrapper from "../pages/park";
import ParksListWrapper from "../pages/park/list/ParksListWrapper";
import ParkProfileLayout from "../pages/park/profile/ParkProfileLayout";
import ParkCarrions from "../pages/park/profile/views/carrions/ParkCarrions";
import ParkCensus from "../pages/park/profile/views/census/ParkCensus";
import ParkDocuments from "../pages/park/profile/views/documents/ParkDocuments";
import ParkIssues from "../pages/park/profile/views/issues/ParkIssues";
import ParkStops from "../pages/park/profile/views/stops/ParkStops";
import ParkTurbines from "../pages/park/profile/views/windTurbines/ParkTurbines";
import StopsWrapper from "../pages/preventive-stops";
import StopsListWrapper from "../pages/preventive-stops/list/StopsListWrapper";
import StopsProfileLayout from "../pages/preventive-stops/profile/StopsProfileLayout";
import StopsInfo from "../pages/preventive-stops/profile/view/StopsInfo";
import StopsPhotos from "../pages/preventive-stops/profile/view/StopsPhotos";
import ReportsWrapper from "../pages/report";
import ReportListWrapper from "../pages/report/list/ReportListWrapper";
import RolesWrapper from "../pages/roles";
import RoleCreate from "../pages/roles/create/RoleCreate";
import RoleEdit from "../pages/roles/edit/RoleEdit";
import RolesListWrapper from "../pages/roles/list/RolesListWrapper";
import SpeciesWrapper from "../pages/species";
import SpeciesListWrapper from "../pages/species/list/SpeciesListWrapper";
import SpeciesInfo from "../pages/species/profile/views/SpeciesInfo";
import UsersWrapper from "../pages/users";
import UserCreate from "../pages/users/create/UserCreate";
import UserEdit from "../pages/users/edit/UserEdit";
import UserEditPermissions from "../pages/users/edit/UserEditPermissions";
import UsersListWrapper from "../pages/users/list/UsersListWrapper";
import UserProfileLayout from "../pages/users/profile/UserProfileLayout";
import UserDocuments from "../pages/users/profile/views/documents/UserDocuments";
import UserInfo from "../pages/users/profile/views/info/UserInfo";
import UserPermissions from "../pages/users/profile/views/permissions/UserPermissions";
import { menuRoutes } from "./menu";
import CensusCreatePage from "../pages/census/create";
import CensusEditPage from "../pages/census/edit";
import OfcEditPage from "../pages/ofc/edit";
import OfcCreatePage from "../pages/ofc/create";
import ParkOFC from "../pages/park/profile/views/ofc/ParkOFC";

const protectedRoutes = [
	/******************************************************
	 * Dashboard
	 ******************************************************/
	{
		path: menuRoutes.dashboard.path,
		element: <Dashboard />,
		access: {
			group: "dashboard",
			action: "get"
		},
	},

	/******************************************************
	 * Organisations
	 ******************************************************/
	{
		path: menuRoutes.organisations.path,
		element: <OrganisationWrapper />,
		sub: [
			{
				element: <OrganisationsListWrapper />,
				access: {
					group: "companies",
					action: "list",
				},
				index: true,
			},
			{
				element: <OrganisationCreate />,
				path: menuRoutes.organisations.create,
				access: {
					group: "companies",
					action: "create"
				}
			},
			{
				element: <OrganisationEdit />,
				path: ':id/edit',
				access: {
					group: "companies",
					action: "edit"
				}
			}
		],
	},

	/******************************************************
	 * Roles
	 ******************************************************/
	{
		path: menuRoutes.roles.path,
		element: <RolesWrapper />,
		sub: [
			{
				element: <RolesListWrapper />,
				access: {
					group: 'roles',
					action: 'list'
				},
				index: true,
			},
			{
				element: <RoleCreate />,
				path: menuRoutes.roles.create,
				access: {
					group: 'roles',
					action: 'create'
				}
			},
			{
				element: <RoleEdit />,
				path: menuRoutes.roles.edit,
				access: {
					group: 'roles',
					action: 'edit'
				}
			},
		]
	},

	/******************************************************
	 * Users
	 ******************************************************/
	{
		path: menuRoutes.users.path,
		element: <UsersWrapper />,
		sub: [
			{
				element: <UsersListWrapper />,
				access: {
					group: 'user',
					action: 'list'
				},
				index: true,
			},
			{
				element: <UserProfileLayout />,
				path: menuRoutes.users.profile.path,
				access: {
					group: 'user',
					action: 'get'
				},
				sub: [
					{
						element: <UserInfo />,
						path: menuRoutes.users.profile.info,
						access: {
							group: 'user',
							action: 'get'
						},
					},
					{
						element: <UserDocuments />,
						path: menuRoutes.users.profile.documents,
						access: {
							group: 'user',
							action: 'get'
						},
					},
					{
						element: <UserPermissions />,
						path: menuRoutes.users.profile.permissions,
						access: {
							group: 'user',
							action: 'get_user_permissions'
						},
					},
				]
			},
			{
				element: <UserCreate />,
				path: menuRoutes.users.create,
				access: {
					group: 'user',
					action: 'create'
				}
			},
			{
				element: <UserEdit />,
				path: menuRoutes.users.edit,
				access: {
					group: 'user',
					action: 'edit'
				}
			},
			{
				element: <UserEditPermissions />,
				path: menuRoutes.users.edit_permissions,
				access: {
					group: 'user',
					action: 'edit_user_permissions'
				}
			},
		]
	},

	/******************************************************
	 * Clients
	 ******************************************************/
	{
		path: menuRoutes.clients.path,
		element: <ClientsWrapper />,
		sub: [
			{
				element: <ClientsListWrapper />,
				access: {
					group: 'clients',
					action: 'list'
				},
				index: true,
			},
			{
				element: <ClientInfo />,
				path: menuRoutes.clients.profile.path + menuRoutes.clients.profile.info,
				access: {
					group: 'clients',
					action: 'get'
				},
			},
			{
				element: <ClientCreate />,
				path: menuRoutes.clients.create,
				access: {
					group: 'clients',
					action: 'create'
				}
			},
			{
				element: <ClientEdit />,
				path: menuRoutes.clients.edit,
				access: {
					group: 'clients',
					action: 'edit'
				}
			},
		]
	},


	/******************************************************
	 * Parks
	 ******************************************************/
	{
		path: menuRoutes.parks.path,
		element: <ParksWrapper />,
		sub: [
			{
				element: <ParksListWrapper />,
				access: {
					group: 'park',
					action: 'list'
				},
				index: true,
			},
			{
				element: <ParkProfileLayout />,
				path: menuRoutes.parks.profile.path,
				access: {
					group: 'park',
					action: 'get'
				},
				sub: [
					{
						element: <ParkTurbines />,
						path: menuRoutes.parks.profile.windTurbines,
						access: {
							group: 'park',
							action: 'get'
						},
					},
					{
						element: <ParkDocuments />,
						path: menuRoutes.parks.profile.documents,
						access: {
							group: 'park',
							action: 'get'
						},
					},
					{
						element: <ParkIssues />,
						path: menuRoutes.parks.profile.issues,
						access: {
							group: 'park',
							action: 'get'
						},
					},
					{
						element: <ParkCarrions />,
						path: menuRoutes.parks.profile.carrion,
						access: {
							group: 'park',
							action: 'get'
						},
					},
					{
						element: <ParkStops />,
						path: menuRoutes.parks.profile.stops,
						access: {
							group: 'park',
							action: 'get'
						},
					},
					{
						element: <ParkCensus />,
						path: menuRoutes.parks.profile.census,
						access: {
							group: 'park',
							action: 'get'
						},
					},
					{
						element: <ParkOFC />,
						path: menuRoutes.parks.profile.ofc,
						access: {
							group: 'park',
							action: 'get'
						},
					},
				]
			}
		]
	},
	/******************************************************
	 * Species
	 * ******************************************************/
	{
		path: menuRoutes.species.path,
		element: <SpeciesWrapper />,
		sub: [
			{
				element: <SpeciesListWrapper />,
				access: {
					group: 'species',
					action: 'list'
				},
				index: true,
			},
			{
				element: <SpeciesInfo />,
				path: menuRoutes.species.profile.path + menuRoutes.species.profile.info,
				access: {
					group: 'species',
					action: 'get'
				},
			},
		]
	},

	/******************************************************
	 * Issues
	 * ******************************************************/

	{
		path: menuRoutes.issues.path,
		element: <IssuesWrapper />,
		sub: [
			{
				element: <IssuesListWrapper />,
				access: {
					group: 'issues',
					action: 'list'
				},
				index: true,
			},
			{
				element: <IssuesProfileLayout />,
				path: menuRoutes.issues.profile.path,
				access: {
					group: 'issues',
					action: 'get'
				},
				sub: [
					{
						element: <IssuesInfo />,
						path: menuRoutes.issues.profile.info,
						access: {
							group: 'issues',
							action: 'get'
						},
					},
					{
						element: <IssuesPhotos />,
						path: menuRoutes.issues.profile.photos,
						access: {
							group: 'issues_photos',
							action: 'get'
						},
					}
				]
			},
		]
	},

	/******************************************************
	 * Carrion
	 ******************************************************/

	{
		path: menuRoutes.carrion.path,
		element: <CarrionWrapper />,
		sub: [
			{
				element: <CarrionListWrapper />,
				access: {
					group: 'carrion',
					action: 'list'
				},
				index: true,
			},
			{
				element: <CarrionProfileLayout />,
				path: menuRoutes.carrion.profile.path,
				access: {
					group: 'carrion',
					action: 'get'
				},
				sub: [
					{
						element: <CarrionInfo />,
						path: menuRoutes.carrion.profile.info,
						access: {
							group: 'carrion',
							action: 'get'
						},
					},
					{
						element: <CarrionPhotos />,
						path: menuRoutes.carrion.profile.photos,
						access: {
							group: 'carrion_photos',
							action: 'get'
						},
					}
				]
			}
		]
	},

	/******************************************************
	 * Census
	 ******************************************************/

	{
		path: menuRoutes.census.path,
		element: <CensusWrapped />,
		sub: [
			{
				element: <CensusListWrapper />,
				access: {
					group: 'census',
					action: 'list'
				},
				index: true,
			},
			{
				element: <CensusCreatePage />,
				path: menuRoutes.census.create,
				access: {
					group: 'census',
					action: 'create'
				},
			},
			{
				element: <CensusEditPage />,
				path: menuRoutes.census.edit,
				access: {
					group: 'census',
					action: 'edit'
				},
			},
			{
				element: <CensusCreatePage fromPark/>,
				path: menuRoutes.census.createFromPark,
				access: {
					group: 'census',
					action: 'create'
				},
			},
			{
				element: <CensusEditPage fromPark/>,
				path: menuRoutes.census.editFromPark,
				access: {
					group: 'census',
					action: 'edit'
				},
			},
			{
				element: <CensusProfileLayout />,
				path: menuRoutes.census.profile.path,
				access: {
					group: 'census',
					action: 'get'
				},
				sub: [
					{
						element: <CensusInfo />,
						path: menuRoutes.census.profile.info,
						access: {
							group: 'census',
							action: 'get'
						},
					},
					{
						element: <CensusPhotos />,
						path: menuRoutes.census.profile.photos,
						access: {
							group: 'census_photos',
							action: 'get'
						},
					}
				]
			}
		]
	},

	/******************************************************
	 * OFC
	 ******************************************************/

	{
		path: menuRoutes.ofc.path,
		element: <OfcWrapper />,
		sub: [
			{
				element: <OfcListWrapper />,
				access: {
					group: 'census',
					action: 'list'
				},
				index: true,
			},
			{
				element: <OfcCreatePage />,
				path: menuRoutes.ofc.create,
				access: {
					group: 'census',
					action: 'create'
				},
			},
			{
				element: <OfcEditPage />,
				path: menuRoutes.ofc.edit,
				access: {
					group: 'census',
					action: 'edit'
				},
			},
			{
				element: <OfcCreatePage fromPark/>,
				path: menuRoutes.ofc.createFromPark,
				access: {
					group: 'census',
					action: 'create'
				},
			},
			{
				element: <OfcEditPage fromPark/>,
				path: menuRoutes.ofc.editFromPark,
				access: {
					group: 'census',
					action: 'edit'
				},
			},
			{
				element: <OfcProfileLayout />,
				path: menuRoutes.ofc.profile.path,
				access: {
					group: 'census',
					action: 'get'
				},
				sub: [
					{
						element: <OfcInfo/>,
						path: menuRoutes.ofc.profile.info,
						access: {
							group: 'census',
							action: 'get'
						},
					},
					{
						element: <OfcPhotos />,
						path: menuRoutes.ofc.profile.photos,
						access: {
							group: 'census',
							action: 'get'
						},
					}
				]
			}
		]
	},

	/******************************************************
	 * Preventive Stops
	 ******************************************************/

	{
		path: menuRoutes.stops.path,
		element: <StopsWrapper />,
		sub: [
			{
				element: <StopsListWrapper />,
				access: {
					group: 'preventive_stops',
					action: 'list'
				},
				index: true
			},
			{
				element: <StopsProfileLayout />,
				path: menuRoutes.stops.profile.path,
				access: {
					group: 'preventive_stops',
					action: 'get'
				},
				sub: [
					{
						element: <StopsInfo />,
						path: menuRoutes.stops.profile.info,
						access: {
							group: 'preventive_stops',
							action: 'get'
						},
					},
					{
						element: <StopsPhotos />,
						path: menuRoutes.stops.profile.photos,
						access: {
							group: 'preventive_stops_photos',
							action: 'get'
						},
					},
				]
			}
		]
	},

	/******************************************************
	 * Documents
	 ******************************************************/

	{
		path: menuRoutes.documents.path,
		element: <DocumentsWrapper />,
		sub: [
			{
				element: <DocumentsListWrapper />,
				access: {
					group: 'document',
					action: 'list'
				},
				index: true
			}
		]
	},

	/******************************************************
	 * Reports
	 ******************************************************/

	{
		path: menuRoutes.reports.path,
		element: <ReportsWrapper />,
		sub: [
			{
				element: <ReportListWrapper />,
				access: {
					group: 'document',
					action: 'list_reports'
				},
				index: true
			}
		]
	}




];

const contents = [...protectedRoutes];
export default contents;